import React from 'react'
import tenantFullNameValueGetter from '../valueGetter/tenantFullNameValueGetter'

const TenantFullNameRenderer = (props) => {
  return <span>{tenantFullNameValueGetter(props)}</span>
}

export default TenantFullNameRenderer
